import styled from 'styled-components';
import { Breakpoints } from '@01_people/ui-library';

export default styled.div`
  width: 100%;

  .kyc-status-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;

    .status-icon {
      margin-bottom: 24px;
    }

    .status-title {
      font-family: Roboto;
      font-size: 30px;
      font-weight: bold;
      font-style: normal;
      font-stretch: condensed;
      line-height: 1.33;
      letter-spacing: normal;
      color: ${({ theme }) => theme.colors.black.color};
      margin-bottom: 16px;
    }

    .status-text {
      font-family: Roboto;
      font-size: 16px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: center;
      color: #213440;
      margin-bottom: 24px;

      white-space: pre-wrap;
    }

    .status-list {
      margin-bottom: 24px;
      padding-inline-start: 0;

      .status-list-item {
        color: ${({ theme }) => theme.colors.error.color};

        margin-bottom: 10px;

        .title {
          font-weight: bold;
          color: ${({ theme }) => theme.colors.error.color};
        }
      }
    }

    .btn-cancel {
      height: auto;
      min-height: 50px;
      border-color: ${({ theme }) => theme.colors.error.color};
      color: ${({ theme }) => theme.colors.error.color};
    }

    .btn-cancel:hover {
      border-color: ${({ theme }) => theme.colors.error.color};
      color: ${({ theme }) => theme.colors.error.color};
      background: ${({ theme }) => theme.colors.error.shades['96']};
    }
  }

  .kyc-inner-block {
    padding-left: 110px;
    padding-right: 110px;
  }

  .expiration {
    justify-content: space-around;
    display: ${props => (props.withoutExpirationDate ? 'none' : 'flex')};
    & > div:not(.mb-20) {
      margin-right: 16px;
    }
    & > div:nth-child(3) {
      margin-right: 0px;
    }
  }

  .text-error {
    margin-top: 4px;
    min-height: 24px;
    vertical-align: center;
    padding-top: 6px;

    p {
      font-size: 12px;
      line-height: 1.33;
      letter-spacing: 0.5px;
      color: ${({ theme }) => theme.colors.error.color};
      margin-bottom: 0;
    }
  }

  .no-expiration-checkbox {
    margin-top: 16px;
  }

  .section-small-heading {
    display: block;
    /* font-family: 'Roboto Condensed', sans-serif; */
    text-transform: uppercase;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.43;
    letter-spacing: 0.5px;
    color: ${({ theme }) => theme.colors.gray.color};
    margin-top: 16px;
    margin-bottom: 8px;
  }

  .upload-info-text {
    font-family: Roboto;
    font-size: 12px;
    line-height: 1.67;
    color: ${({ theme }) => theme.colors.gray.color};
    ul li {
      margin-top: 0.5rem;
      color: ${({ theme }) => theme.colors.gray.color};
    }
  }

  .save-wrapper {
    text-align: right;
  }

  @media (max-width: ${Breakpoints.maxSmall}) {
    h5 {
      font-family: Roboto;
      font-size: 20px;
      font-weight: bold;
      font-style: normal;
      font-stretch: condensed;
      line-height: 1.2;
      letter-spacing: normal;
      color: ${({ theme }) => theme.colors.black.color};
    }

    h6 {
      font-family: Roboto;
      font-size: 16px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.25;
      letter-spacing: normal;
      color: ${({ theme }) => theme.colors.black.color};
    }

    .kyc-inner-block {
      padding: 0 16px;
      padding-bottom: 0px;
      /* min-height: calc(100vh - 106px - 24px - 48px); */
      /* 106px - upper menu, 24px - padding of content, 48px - bottom stepper */

      .wrapper-success {
        min-height: calc(100vh - 106px - 24px - 48px);
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .success-check-svg,
        .success-text,
        .back-huulk {
          margin-bottom: 26px;
        }

        .success-check-svg {
          margin-top: -100px;
        }

        .success-text {
          font-family: Roboto;
          font-size: 16px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.5;
          letter-spacing: normal;
          text-align: center;
          color: ${({ theme }) => theme.colors.success.color};
          max-width: 50%;
        }

        .back-huulk {
          font-size: 14px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.43;
          letter-spacing: 0.39px;
          text-align: center;
          color: ${({ theme }) => theme.colors.success.color};
          background-color: rgba(0, 0, 0, 0);
          border-radius: 4px;
          border: solid 1px ${({ theme }) => theme.colors.success.color};

          &:hover {
            background-color: ${({ theme }) =>
              theme.colors.success.shades['96']};
          }
        }
      }
    }

    .stepper {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      height: 48px;
      background-color: ${({ theme }) => theme.colors.gray.shades['95']};
      align-items: center;
      margin-bottom: env(safe-area-inset-bottom);

      .progress-bar {
        width: 100%;
        text-align: center;
        height: 3px;
        background-color: ${({ theme }) => theme.colors.gray.shades['85']};
        margin: 0 33%;
        position: relative;
        z-index: 1;
        border-radius: 100px;
        overflow: hidden;

        span {
          transition: width 0.5s ease-out;
          position: relative;
          display: block;
          height: 100%;
          background-color: ${({ theme }) => theme.colors.primary.color};
          z-index: 2;
        }
      }

      .btn {
        width: 74px;
        height: 40px;
        margin: 4px 3px;
        padding: 0px;
        font-family: Roboto;
        font-size: 14px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: 0.5px;
        text-align: center;
        color: #ffffff;

        &.prev-btn {
          position: absolute;
          left: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0);
          font-family: Roboto;
          letter-spacing: normal;
          color: ${({ theme }) => theme.colors.primary.color};
          font-weight: normal;
        }

        &.next-btn {
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }
    }
  }
`;
